<div class="flex-row column full">
  <div class="flex-row column full row-gap-20 p-20">
    <div class="flex-row align-center column-gap-10">
      <button type="button" class="tw-bg-transparent tw-border-0 tw-p-0" (click)="close(false)">
        <img class="cursor-pointer" src="assets/new-assets/icons/icon-arrow-back.svg" alt="Go back">
      </button>
      <p class="text-dark fs-20 fw-8 fs-md-16">Update Investpack Holdings</p>
    </div>
    <span class="color-secondary fs-md-14">Choose the Investpack you want to update </span>
    <app-custom-dropdown [isObject]="true" [key]="'wealthcaseName'" [value]="'_id'"
      [placeHolder]="'Choose Your Investpack'" [optionsList]="subscribedPacks"
      (selectedOption)="selectedPack($event)"></app-custom-dropdown>
    <!-- <div class="flex-row align-center content-center-md p-10 bg-color-FEFAE7">
      <p class="color-secondary fs-14">Status message > for 1st transaction</p>
    </div> -->
  </div>
  <app-loader *ngIf="isLoading"></app-loader>
  <ng-container *ngIf="!isLoading">
    <ng-container *ngIf="!isInvested && investpackInstruments.length">
      <ng-template [ngTemplateOutlet]="notInvested"></ng-template>
    </ng-container>
    <ng-container *ngIf="isInvested && investpackInstruments.length">
      <ng-template [ngTemplateOutlet]="invested"></ng-template>
    </ng-container>
  </ng-container>
  <div class="flex-row align-center content-center column-gap-30 p-15 border-top-1 bg-white">
    <button type="button" class="btn color-blue border-color-DCEBEF text-uppercase fw-7 width-16"
      (click)="close(false)">Cancel</button>
    <button type="button" class="btn btn-primary text-uppercase fw-7 width-16"
      (click)="updateExternalHolding()">update</button>
  </div>
</div>


<ng-template #notInvested>
  <!-- <div class="flex-row align-center content-between full row-gap-20 column-gap-10 bg-color-F7F8F7 pt-10 pb-10 pr-20 pl-20 color-secondary fw-6 fs-14">
    <div>SCRIP</div>
    <div class="width-60-pr flex-row content-between column-gap-10">
      <div class="width-7 min-width-7"></div>
      <div class="width-10 text-right">Qty</div>
      <div class="width-20 text-right">Price per share</div>
    </div>
  </div> -->
  <div
    class="flex-row align-center content-between full column-gap-10 row-gap-20 bg-color-F7F8F7 pt-10 pb-10 pr-20 pl-20 color-secondary fw-6 fs-14 d-none-md">
    <div class="width-25-pr">SCRIP</div>
    <div class="flex-row align-center content-between width-70-pr">
      <div class="width-20-pr text-center"></div>
      <div class="width-25-pr text-right">Qty</div>
      <div class="width-45-pr text-right">Price per share</div>
    </div>
  </div>
  <form class="flex-row column full row-gap-20 p-20 max-height-5-vh overflow-y" [formGroup]="updateInvestpackForm">
    <ng-container formArrayName="instruments" *ngFor="let stocks of getControlsArr().controls; let i = index">
      <div
        class="flex-row align-center content-between full row-gap-20 column-gap-10 column-md pb-15 border-bottom-color-ECF3F5"
        [formGroupName]="i">
        <div class="flex-row align-center width-25-pr full-md content-between column-gap-20">
          <div class="flex-row align-center column-gap-10 max-width-80-pr">
            <div class="img rectangle flex-row">
              <img class="margin-auto" *ngIf="stocks?.instruments?.logo"
                src="{{stockBaseUrl}}{{stocks?.instruments?.logo}}" [alt]="stocks.controls['name'].value">
              <img class="margin-auto" *ngIf="!stocks?.instruments?.logo"
                src="assets/new-assets/icons/default-stock.png" [alt]="stocks.controls['name'].value">
            </div>
            <p class="fs-14 fw-6 text-dark">{{stocks.controls['name'].value}}</p>
          </div>
          <div class="flex-row align-center column-gap-20 d-none d-flex-md">
            <p class="text-success text-center fs-14 fw-7 ">{{stocks.controls['scriptType'].value}}</p>
            <!-- <img class="cursor-pointer" src="assets/new-assets/icons/icon-remove-circle.svg" alt=""> -->
          </div>
        </div>
        <div class="flex-row align-center content-between width-70-pr full-md">
          <div class="p-10 border-1 width-20-pr border-radius-4 d-none-md">
            <p class="text-success text-center fs-14 fw-7">{{stocks.controls['scriptType'].value}}</p>
          </div>
          <div class="width-25-pr width-md-45-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Qty</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6" formControlName="quantity"
              type="number">
          </div>
          <div class="width-45-pr width-md-45-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Price per share</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              formControlName="purchasePrice" type="number">
          </div>
        </div>
      </div>
    </ng-container>
  </form>
</ng-template>

<ng-template #invested>
  <div
    class="flex-row align-center content-between full column-gap-10 row-gap-20 bg-color-F7F8F7 pt-10 pb-10 pr-20 pl-20 color-secondary fw-6 fs-14 d-none-md">
    <div class="width-25-pr">SCRIP</div>
    <div class="flex-row align-center content-between width-50-pr">
      <div class="width-25-pr text-center">Previous QTY</div>
      <div class="width-25-pr text-center">Current QTY</div>
      <div class="width-25-pr text-center">Diff</div>
      <div class="width-20-pr text-center"></div>
    </div>
    <div class="width-25-pr text-center">Price per share</div>
  </div>
  <div class="flex-row column full row-gap-20 p-20 max-height-6-vh overflow-y" [formGroup]="updateInvestpackForm">
    <ng-container formArrayName="instruments" *ngFor="let stocks of getControlsArr().controls; let i = index">
      <div
        class="flex-row align-center content-between full row-gap-20 column-gap-10 column-md pb-15 border-bottom-color-ECF3F5"
        [formGroupName]="i">
        <div class="flex-row align-center width-25-pr full-md content-between column-gap-md-20">
          <div class="flex-row align-center column-gap-10 max-width-80-pr">
            <div class="img rectangle flex-row">
              <img class="margin-auto" *ngIf="stocks?.instruments?.logo"
                src="{{stockBaseUrl}}{{stocks?.instruments?.logo}}" [alt]="stocks.controls['name'].value">
              <img class="margin-auto" *ngIf="!stocks?.instruments?.logo"
                src="assets/new-assets/icons/default-stock.png" [alt]="stocks.controls['name'].value">
            </div>
            <p class="fs-14 fw-6 text-dark">{{stocks.controls['name'].value}}</p>
          </div>
          <div class="flex-row align-center column-gap-20 d-none d-flex-md">
            <p class="text-center fs-14 fw-7"
              [class]="stocks.controls['scriptType'].value === 'BUY' ? 'text-success': 'text-danger'">
              {{stocks.controls['scriptType'].value}}</p>
            <!-- <img class="cursor-pointer" src="assets/new-assets/icons/icon-remove-circle.svg" alt=""> -->
          </div>
        </div>
        <div class="flex-row align-center content-between width-70-pr full-md">
          <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Previous QTY.</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              formControlName="oldQuantity" type="number">
          </div>
          <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10">
            <p class="color-5A627A fs-14 d-none d-block-md">Current QTY.</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              (input)="changeCurrentQty(i)" formControlName="newQuantity" type="number">
          </div>
          <div class="p-10 border-1 width-20-pr border-radius-4 d-none-md">
            <p class="text-center fs-14 fw-6 text-dark">{{(stocks | qtyDiff) | number: '1.2-2'}}</p>
          </div>
          <div class="p-10 border-1 width-20-pr border-radius-4 d-none-md">
            <p class="text-center fs-14 fw-7"
              [class]="stocks.controls['scriptType'].value === 'BUY' ? 'text-success': 'text-danger'">
              {{stocks.controls['scriptType'].value}}</p>
          </div>
          <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10 d-none d-flex-md">
            <p class="color-5A627A fs-14 d-none d-block-md">Price per unit</p>
            <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
              formControlName="purchasePrice" type="number">
          </div>
        </div>
        <div class="flex-row align-center content-end d-none d-flex-md full" *ngIf="stocks | qtyDiff">
          <p class="color-5A627A fs-14 mr-15">Diff : </p>
          <p class="fs-14">{{(stocks | qtyDiff) | number: '1.2-2'}} QTY.</p>
        </div>
        <div class="width-25-pr width-md-30-pr align-center flex-row column row-gap-md-10 d-none-md">
          <p class="color-5A627A fs-14 d-none d-block-md">Price per unit</p>
          <input class="p-10 border-1 text-right full border-radius-4 text-dark fs-14 fw-6"
            formControlName="purchasePrice" type="number">
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>